import { useState, useEffect } from 'react';
import Section from './components/Section';
import ExperienceSection from './components/ExperienceSection';
import Header from './components/Header';
import TechnologiesSection from './components/TechnologiesSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import experiences from './data/experiences.json';
import technologies from './data/technologies.json';
import projects from './data/projects.json';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simular tiempo de carga
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <div className="app">
      <Section className="hero-section">
        <Header />
      </Section>

      <ExperienceSection experiences={experiences.experiences} />

      <Section className="skills-section" title="Tech Habilities">
        <TechnologiesSection experiences={experiences.experiences} technologies={technologies.technologies} />
      </Section>

      <Section className="projects-section" title="Latest Personal Projects">
        <ProjectsSection projects={projects.projects} />
      </Section>

      <ContactSection />

      <Footer lastUpdateDate={getLastUpdateDate()} />
    </div>
  );
}

// Función para obtener la fecha de última actualización
// Usa la fecha más reciente de las experiencias como referencia
function getLastUpdateDate() {
  // Obtener la fecha más reciente de las experiencias (startDate o endDate)
  const allDates = experiences.experiences.flatMap(exp => {
    const dates = [new Date(exp.startDate + '-01')];
    if (exp.endDate !== 'nowadays') {
      dates.push(new Date(exp.endDate + '-01'));
    } else {
      dates.push(new Date()); // Si es "nowadays", usar fecha actual
    }
    return dates;
  });
  
  // Retornar la fecha más reciente
  return allDates.sort((a, b) => b - a)[0] || new Date();
}

export default App;
